
<div class="map-dialog-content-wrapper" >        
    <mat-toolbar matDialogTitle class="mat-accent m-0 mb-24">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" style="overflow:hidden">            
            <span class="title dialog-title text-truncate">{{title}}</span>
            <button mat-icon-button class="mat-icon-button white-fg" 
                    (click)="CloseDialog()"
                    aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>            
        </div>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0 pt-0" fusePerfectScrollbar>        
        <div id="divMap" style="width:800px; height:550px">
        </div>  
    </div>
</div>